import { Tooltip, createStyles, makeStyles, useTheme } from '@material-ui/core';
import React, { Fragment } from 'react';
import { AngleRightIcon, AngleUpIcon } from '../Icons';
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography } from '../..';
const useStyles = makeStyles((theme) => createStyles({
    root: {
        backgroundColor: 'white',
        display: 'flex',
        textAlign: 'center',
        padding: theme.spacing(0, 3),
    },
    content: {
        justifyContent: 'space-between',
        alignItems: 'center',
        height: theme.spacing(3),
        margin: theme.spacing(3, 0),
    },
    avatarClass: {
        height: theme.spacing(3),
        minWidth: theme.spacing(3),
        marginRight: theme.spacing(1),
        padding: theme.spacing(0, 1),
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        borderRadius: 100,
        display: 'flex',
        backgroundColor: theme.palette.primary.light,
    },
    expandIcon: {
        fontSize: 24,
    },
    contentDetails: {
        padding: theme.spacing(2, 3),
    },
    typography: {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            fontSize: 36,
            paddingRight: theme.spacing(1),
        },
    },
    expansionRoot: {
        backgroundColor: 'inherit',
        '&:before': {
            display: 'none',
        },
    },
}));
const SidebarExpansionPanel = ({ children, title, icon, expanded, badgeCounter, tooltipText, ...rest }) => {
    const typographyColorAddition = expanded ? { color: 'secondary' } : {};
    const theme = useTheme();
    const classes = useStyles();
    return (React.createElement(ExpansionPanel, Object.assign({ square: true, elevation: 0, classes: { root: classes.expansionRoot }, expanded: expanded }, rest),
        React.createElement(ExpansionPanelSummary, { classes: { root: classes.root, content: classes.content }, expandIcon: expanded ? React.createElement(AngleUpIcon, { className: classes.expandIcon }) : React.createElement(AngleRightIcon, { className: classes.expandIcon }), style: expanded ? { borderBottom: `1px solid ${theme.palette.divider}` } : undefined },
            React.createElement(Typography, Object.assign({ variant: "h6" }, typographyColorAddition, { className: classes.typography }), tooltipText ? (React.createElement(Tooltip, { title: tooltipText, placement: "top" },
                React.createElement("span", null,
                    icon,
                    " ",
                    title))) : (React.createElement(Fragment, null,
                icon,
                " ",
                title))),
            !!badgeCounter && (React.createElement(Typography, { className: classes.avatarClass, variant: "caption" }, badgeCounter))),
        React.createElement(ExpansionPanelDetails, { className: classes.contentDetails, style: { backgroundColor: 'inherit', border: 'none' } }, children)));
};
export default SidebarExpansionPanel;
//# sourceMappingURL=SidebarExpansionPanel.js.map